import { store } from "../redux/store";
import { deleteUser, updateJwt } from "../redux/userSlice";
import axios from "axios";
import { BASE_URL } from "../settings";

const axiosAuthInstance = axios.create({
    baseURL: BASE_URL,
});

axiosAuthInstance.interceptors.request.use(
    (config) => {
        const state = store.getState();
        const user = state.user;
        if (user.jwt) {
            config.headers.Authorization = user.jwt;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// BUG-004/BUG-028: cuando el token expira el backend responde 401. Primero se
// intenta renovar silenciosamente con el refresh token (una sola vez por
// request, via _retried); si no hay refresh token o la renovación falla, se
// limpia la sesión y se redirige al login para una salida ordenada, en vez de
// dejar que fallen todos los recursos ("errores por todas partes").
let isHandlingSessionExpiry = false;

axiosAuthInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response?.status !== 401 || isHandlingSessionExpiry) {
            return Promise.reject(error);
        }

        const originalRequest = error.config;
        if (originalRequest && !originalRequest._retried) {
            originalRequest._retried = true;
            const refreshToken = store.getState().user.refreshToken;
            if (refreshToken) {
                try {
                    const { data } = await axios.post(
                        `${BASE_URL}auth/token/refresh/`,
                        { refresh_token: refreshToken }
                    );
                    store.dispatch(updateJwt(data.jwt));
                    originalRequest.headers.Authorization = data.jwt;
                    return axiosAuthInstance(originalRequest);
                } catch {
                    // Falls through to session cleanup below.
                }
            }
        }

        store.dispatch(deleteUser());
        sessionStorage.removeItem('jwt');
        // Sólo redirige si no estamos ya en el login; el reload limpia el flag.
        if (window.location.pathname !== '/') {
            isHandlingSessionExpiry = true;
            window.location.href = '/';
        }
        return Promise.reject(error);
    }
);

export const axiosAuth = () => axiosAuthInstance;

export const axiosWithoutAuth = () => {
    return axios.create({
        baseURL: BASE_URL,
    });
};
